import { render } from "./_CviCodeSnippetInline.vue?vue&type=template&id=49b3c5c8"
import script from "./_CviCodeSnippetInline.vue?vue&type=script&lang=js"
export * from "./_CviCodeSnippetInline.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/carbon-components-vue/carbon-components-vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__